import Service from './service';

export const Menus = () => {
    return Service.Get('/menu_items/main?_format=json');
}

export const FilterBrands = () => {
    return Service.Get('/taxonomy/filter/brands?_format=json');
}

export const commonDetailService = (retailerId) => {
    return Service.Get('/site-settings/' + retailerId+'?_format=json');
}
